import { useEffect } from 'react';

export const SetTopTab = (title) => {
    useEffect(() => {
        document.title = title;
    }, []);

    return <div>Welcome to My App!</div>;
};